"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const ThemeDiv = _styledComponents.default.div`
  --primary: ${props => props.theme.primary};
  --accent: ${props => props.theme.accent};

  --black: ${props => props.theme.black};
  --white: ${props => props.theme.white};

  --error: ${props => props.theme.error};

  --font: ${props => props.theme.font};
`;
var _default = exports.default = ThemeDiv;